import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchAnnouncements } from "../../actions/announcementActions";
import "./system-notice-banner.scss";

const POLL_INTERVAL_MS = 60000;
const ICONS = { info: "i", warning: "!", critical: "!" };

export class SystemNoticeBanner extends Component {
  componentDidMount() {
    if (this.props.fetchAnnouncements) {
      this.props.fetchAnnouncements();
      this.intervalId = setInterval(
        this.props.fetchAnnouncements,
        POLL_INTERVAL_MS,
      );
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    const { items } = this.props;
    if (!items || items.length === 0) {
      return null;
    }
    return (
      <div
        className="system-notice-banner"
        role="status"
        aria-live="polite"
        aria-atomic="false"
      >
        {items.map((item) => (
          <div
            key={item.id}
            className={`system-notice-banner__row ${item.severity}`}
          >
            <span className="system-notice-banner__icon">
              {ICONS[item.severity] || "i"}
            </span>
            <span className="system-notice-banner__message">
              {item.message}
            </span>
          </div>
        ))}
      </div>
    );
  }
}

SystemNoticeBanner.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      message: PropTypes.string.isRequired,
      severity: PropTypes.string.isRequired,
    }),
  ),
  fetchAnnouncements: PropTypes.func.isRequired,
};

SystemNoticeBanner.defaultProps = {
  items: [],
};

const mapStateToProps = ({ announcements }) => ({
  items: announcements.items,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAnnouncements: () => dispatch(fetchAnnouncements()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SystemNoticeBanner);
